<template>
  <div class="page">
    <table class="end-table">
        <tbody>
            <tr>
                <td>Score Received</td>
                <td>{{score}} scores</td>
            </tr>
            <tr>
                <td>Check Answer</td>
                <td>
                  <img src="~@/assets/check.png" alt="" @click="_goReview">
                </td>
            </tr>
            <tr>
                <td>Continue to Answer</td>
                <td>
                  <img src="~@/assets/answer.png" alt="" @click="_goMyqs">
                </td>
            </tr>
            <tr>
                <td>Challenge More</td>
                <td>
                  <img src="~@/assets/challenge.png" @click="_getMore" alt="">
                </td>
            </tr>
        </tbody>
    </table>
    <van-popup v-model="showSharePop" position="bottom">
      <social-sharing v-bind:url="shareUrl" v-bind:title="shareTitle" v-bind:description="shareDesc" v-bind:quote="shareDesc" hashtags="Prize,Quiz,Million MMK" inline-template>
            <div>
              <ul class='share-list'>
                <li class='share-item'>
                  <network network="facebook">
                    <i class="fa fa-facebook"></i> Facebook
                  </network>
                </li>
                <li class='share-item'>
                  <network network="googleplus">
                    <i class="fa fa-google-plus"></i> Google +
                  </network>
                </li>
                <li class='share-item'>
                  <network network="linkedin">
                    <i class="fa fa-linkedin"></i> LinkedIn
                  </network>
                </li>
                <li class='share-item'>
                  <network network="twitter">
                    <i class="fa fa-twitter"></i> Twitter
                  </network>
                </li>
                <li class='share-item'>
                  <network network="vk">
                    <i class="fa fa-vk"></i> VKontakte
                  </network>
                </li>
                <li class='share-item'>
                  <network network="whatsapp">
                    <i class="fa fa-whatsapp"></i> Whatsapp
                  </network>
                </li>
              </ul>
            </div>
          </social-sharing>
    </van-popup>
  </div>
</template>
<script>

import { mapState, mapActions } from 'vuex'
export default {
  name: 'End',
  computed: {
    ...mapState(['lang', 'langMap']),
  },
  data() {
    return {
      duration: '',
      score: '',
      win: '',
      showSharePop: false,
      shareUrl: 'http://qs.wobangta.com/#/share',
      shareTitle: '',
      shareDesc: '',
      questionId: this.$route.query.id
    }
  },
  created() {
    Utils.$ajax({
      type: 'post',
      url: '/core/result',
      data: {question_id: this.questionId}
    }).done(res => {
      if (res.code != 0) {
        this.$toast(res.msg);
      } else {
        this.duration = res.data.time;
        this.score = res.data.score;
        this.win = res.data.win
      }
    })
  },
  methods: {
    _getMore(){
      let url = this.$parent.baseHomeUrl + "/buy?mobile=";
      window.location = url + localStorage.localMisisdn;
    },
    _goReview() {
      this.$router.push(`/review?id=${this.questionId}`)
    },
    _goMyqs(){
      this.$router.push({name:'Myqs'})
    },
    _showShare() {
      Utils.$ajax({
          type: 'get',
          url: '/share/result'
      }).done(res=>{
          if(res.code != 0) return;
          this.showSharePop = true;
          this.shareTitle = res.data.title;
          this.shareDesc = res.data.desc;
          this.shareUrl = res.data.link;
      });
    }
  }
}

</script>
<style lang="scss">
.page{
  padding: 0 1em;
}
.end-table{
  width: 100%;
  td{
    text-align:center;
    padding: 1em 0;
  }
  img{
    width: rem(96);
    height: rem(96);
  }
  tr:first-child{
    font-weight: bold;
  }
}
.sharePop {
  width: 100%;
  color: #000;
  padding: 20px 10px;
}

.share-item{
  display: inline-block;
  border: 1px #eee solid;
  margin: 5px;
  padding: .5em;
}

</style>



// WEBPACK FOOTER //
// src/components/End.vue